import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "hooks/redux";
import Cookies from "js-cookie";
import {
    resetError,
    getTabById,
    resetTabsStateForRobot,
    getTickers,
} from "store/reducers/TabsSlice";
import {
    resetQuotesPageState,
    setActivePage,
} from "store/reducers/QuotesPageReducer";
import errorNotification from "utils/Notifications/Error";
import { useDispatch } from "react-redux";
import { Grid } from "components/common/Grid";
import { useDragContext } from "components/drag";
import { deepEqual } from "fast-equals";
import { resetQuotesState, setActivePageId } from "store/reducers/quotes";
import { resetFilterState } from "store/reducers/FilterSlice";
import WS from "utils/ws";

const QuotesPageUpdater = () => {
    const dispatch = useDispatch();

    const { selectedRobotId } = useAppSelector((state) => state.robots);
    const prevSelectedRobotId = useRef(selectedRobotId);
    const active_page_id = useAppSelector(
        (state) => state.quotes.active_page_id,
    );

    const { error, tabs, workspaces } = useAppSelector((state) => state.tabs);
    const { dispatch: _dispatch } = useDragContext();
    const [memo_workspaces, set_memo_workspaces] = useState<any[]>([]);
    useEffect(() => {
        const check = deepEqual(
            memo_workspaces.slice().sort((a, b) => a?.id - b?.id),
            workspaces.slice().sort((a, b) => a?.id - b?.id),
        );
        if (
            (!memo_workspaces.length && workspaces.length) ||
            (!check &&
                !memo_workspaces.some((x) => x?.id === workspaces[0]?.id))
        ) {
            set_memo_workspaces(workspaces);
        }
    }, [memo_workspaces, workspaces]);

    useEffect(() => {
        if (!memo_workspaces.length) {
            return;
        }

        const new_drag_items = memo_workspaces?.map((item, i) => ({
            id: item.id.toString(),
            value: i + 1,
        }));
        _dispatch({
            type: "SET_ITEMS",
            payload: new_drag_items,
        });
    }, [_dispatch, memo_workspaces]);

    useEffect(() => {
        if (!selectedRobotId) return;
        if (!tabs || tabs.length === 0) return;
        const cookieKey = `activePageId_${selectedRobotId}`;
        const savedId = Cookies.get(cookieKey);
        const tabExists = tabs.some(
            (tab) => String(tab.id) === String(savedId),
        );

        if (tabExists && savedId) {
            dispatch(setActivePageId(savedId));
            dispatch(setActivePage(parseInt(savedId)));
        } else {
            console.warn(
                `[RESTORE SKIP] Tab ${savedId} not found in current robot tabs`,
            );
        }
    }, [selectedRobotId, tabs, dispatch]);



    useEffect(() => {
        if (!error) return;
        errorNotification(error);
        dispatch(resetError());
    }, [error]);

    useEffect(() => {
        if (!selectedRobotId || !active_page_id) return;
        if (
            typeof active_page_id !== "string" ||
            (typeof active_page_id === "string" && !active_page_id.length)
        ) {
            return;
        }
        if (!tabs.some((t) => String(t.id) === String(active_page_id))) {
            console.warn(
                `[BLOCKED FETCH] Tab ${active_page_id} not in robot ${selectedRobotId} tabs`,
            );
            return;
        }
        dispatch(getTabById(+active_page_id));
        //@ts-ignore
        // dispatch(getAreasByTabId({ id: +active_page_id }));
    }, [active_page_id, selectedRobotId, tabs]);
    useEffect(() => {
        Cookies.remove("activePageId");
    }, []);
    if (!active_page_id || !selectedRobotId) {
        return (
            <Grid w="100%" h="100%" justify="center" align="center">
                <h1>Выберите или создайте вкладку</h1>
            </Grid>
        );
    }
    return <></>;
};

export default QuotesPageUpdater;
